import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL || (
  process.env.NODE_ENV === 'production' ? 'https://api.oscrm.casdev.com.br' : 'http://localhost:5000'
)

const instance = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
})

instance.interceptors.request.use(config => {
  const token = sessionStorage.getItem('token') || localStorage.getItem('token')
  if (token) config.headers.Authorization = token
  return config
})

const token = sessionStorage.getItem('token') || localStorage.getItem('token')
if (token) instance.defaults.headers.common.Authorization = token

export default instance
